import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import TablePagination from "./TablePagination";
import { getContactUsData } from "../Apis/ContactUsAPIs";

const ContactUsLayer = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await getContactUsData();
            if (res.status) {
                const fetchedData = res.response?.data || res.response || [];
                setData(Array.isArray(fetchedData) ? fetchedData : []);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching contact data", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const filteredData = data.filter(item =>
        (item?.name || item?.fullName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.email || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.phone || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item?.message || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalRecords = filteredData.length;
    const totalPages = Math.ceil(totalRecords / rowsPerPage);
    const paginatedData = filteredData.slice(
        currentPage * rowsPerPage,
        (currentPage + 1) * rowsPerPage
    );

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setCurrentPage(0);
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}>
                <h6 className="text-white pb-2 mb-0">Contact Us List</h6>
                <div className="d-flex align-items-center gap-3">
                    <form className="navbar-search" onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="text"
                            className="bg-base h-40-px w-auto"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(0);
                            }}
                            style={{ color: "black" }}
                        />
                        <Icon icon="ion:search-outline" className="icon" style={{ color: "black" }} />
                    </form>
                </div>
            </div>
            <div className="card-body p-24">
                <div className="table-responsive">
                    <table className="table bordered-table sm-table mb-0" style={{ verticalAlign: "middle" }}>
                        <thead>
                            <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                                <th scope="col" style={{ color: "white", fontWeight: "bold", width: "60px", textAlign: "center" }}>S.No</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold", minWidth: "150px" }}>Full Name</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold", minWidth: "200px" }}>Email Address</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold", minWidth: "130px" }}>Phone Number</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold", minWidth: "280px", maxWidth: "350px" }}>Message</th>
                                <th scope="col" style={{ color: "white", fontWeight: "bold", minWidth: "110px", textAlign: "center" }}>Date</th>
                                {/* <th scope="col" style={{ color: "white", fontWeight: "bold", width: "90px", textAlign: "center" }}>Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="7" className="text-center py-40">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : paginatedData.length > 0 ? (
                                paginatedData.map((item, index) => {
                                    const msgText = item.message || "";
                                    const isLong = msgText.length > 80;

                                    return (
                                        <tr key={index}>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>{currentPage * rowsPerPage + index + 1}</td>
                                            <td style={{ verticalAlign: "middle", fontWeight: "500" }}>{item.name || item.fullName || "N/A"}</td>
                                            <td style={{ verticalAlign: "middle" }}>{item.email || "N/A"}</td>
                                            <td style={{ verticalAlign: "middle" }}>{item.phone || "N/A"}</td>
                                            <td style={{ verticalAlign: "middle", maxWidth: "350px" }}>
                                                <div
                                                    style={{
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        wordBreak: "break-word",
                                                        lineHeight: "1.4",
                                                        fontSize: "13px",
                                                        color: "#333"
                                                    }}
                                                    title={msgText}
                                                >
                                                    {msgText || "N/A"}
                                                </div>
                                                {isLong && (
                                                    <button
                                                        type="button"
                                                        onClick={() => setSelectedItem(item)}
                                                        className="btn p-0 border-0 text-primary fw-semibold"
                                                        style={{ fontSize: "12px", marginTop: "4px", textDecoration: "underline", cursor: "pointer" }}
                                                    >
                                                        Read More
                                                    </button>
                                                )}
                                            </td>
                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                {item.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB') : "N/A"}
                                            </td>
                                            {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                <button
                                                    type="button"
                                                    onClick={() => setSelectedItem(item)}
                                                    className="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center p-2 radius-8"
                                                    title="View Details"
                                                >
                                                    <Icon icon="solar:eye-bold" style={{ fontSize: "16px" }} />
                                                </button>
                                            </td> */}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="6" className="text-center py-40">
                                        <div className="text-secondary-light">No records found.</div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {totalRecords > 0 && (
                    <TablePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleRowsPerPageChange}
                        totalRecords={totalRecords}
                    />
                )}
            </div>

            {/* MESSAGE DETAILS MODAL */}
            {selectedItem && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
                    onClick={() => setSelectedItem(null)}
                >
                    <div
                        className="modal-dialog modal-dialog-centered modal-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-content radius-16 border-0 shadow-lg">
                            <div
                                className="modal-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between text-white radius-top-16"
                                style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}
                            >
                                <h5 className="modal-title text-white mb-0 fs-18 fw-bold">Contact Enquiry Details</h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => setSelectedItem(null)}
                                ></button>
                            </div>
                            <div className="modal-body p-24">
                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label text-muted fs-13 mb-1">Full Name</label>
                                        <div className="fw-bold fs-15 text-dark">{selectedItem.name || selectedItem.fullName || "N/A"}</div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-muted fs-13 mb-1">Date</label>
                                        <div className="fw-semibold fs-15 text-dark">
                                            {selectedItem.createdAt ? new Date(selectedItem.createdAt).toLocaleString('en-GB') : "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-muted fs-13 mb-1">Email Address</label>
                                        <div className="fw-medium fs-14 text-dark">
                                            {selectedItem.email ? (
                                                <a href={`mailto:${selectedItem.email}`} className="text-primary text-decoration-none">
                                                    {selectedItem.email}
                                                </a>
                                            ) : "N/A"}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label text-muted fs-13 mb-1">Phone Number</label>
                                        <div className="fw-medium fs-14 text-dark">
                                            {selectedItem.phone ? (
                                                <a href={`tel:${selectedItem.phone}`} className="text-dark text-decoration-none">
                                                    {selectedItem.phone}
                                                </a>
                                            ) : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <hr className="my-3 text-secondary opacity-25" />
                                <div>
                                    <label className="form-label text-muted fs-13 mb-2 fw-semibold">Message</label>
                                    <div
                                        className="p-3 bg-light radius-8 border text-dark fs-14"
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            maxHeight: "250px",
                                            overflowY: "auto",
                                            lineHeight: "1.6"
                                        }}
                                    >
                                        {selectedItem.message || "No message provided."}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer border-top py-12 px-24">
                                <button
                                    type="button"
                                    className="btn btn-secondary radius-8 px-20"
                                    onClick={() => setSelectedItem(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ContactUsLayer;
